import { connect } from 'react-redux'

import GestionUsers from '../../../pages/settings/Users'
import {
  resetSuccessAction,
  fetchParticipants,
  onSearch,
  pageChanged,
  pageLimitChanged,
  removeError,
  resetParticipantConfig,
  roleUserFiltreChange,
} from '../../../redux/participants/actions'

import {
  getParticipants,
  getParticipantsCount,
  getParticipantsListIsLoading,
  getErrorMessage,
  getIsErrorFetch,
  getIsSuccessRefresh,
  getSuccess,
} from '../../../redux/participants/selectors'
import { getErrorMessageConfig } from '../../../redux/configuration/selectors'
import { removeErrorConfig } from '../../../redux/configuration/actions'

const mapStateToProps = (state) => ({
  isLoadingUserList: getParticipantsListIsLoading(state),
  users: getParticipants(state),
  userCount: getParticipantsCount(state),
  errorMessage: getErrorMessage(state),
  isErrorFetch: getIsErrorFetch(state),
  isSuccessRefresh: getIsSuccessRefresh(state),
  success: getSuccess(state),
  errorMessageConfig: getErrorMessageConfig(state),
})

const mapDisptachToProps = (dispatch) => ({
  fetchData: () => {
    dispatch(roleUserFiltreChange())
    dispatch(fetchParticipants())
  },
  pageLimitChanged: (limit) => {
    dispatch(pageLimitChanged(limit))
    dispatch(fetchParticipants())
  },
  pageChanged: (offset) => {
    dispatch(pageChanged(offset))
    dispatch(fetchParticipants())
  },
  removeError: () => dispatch(removeError()),
  removeErrorConfig: () => dispatch(removeErrorConfig()),
  resetSuccessAction: () => dispatch(resetSuccessAction()),
  onCloseReset: () => dispatch(resetParticipantConfig()),

  searchData: (search) => {
    dispatch(onSearch(search))
    dispatch(fetchParticipants())
  },
})

export default connect(mapStateToProps, mapDisptachToProps)(GestionUsers)
